import React from "react";
import { Message } from "semantic-ui-react";
import { FormattedMessage } from "react-intl";
import messages from "./messages";
import styles from "./styles.module.scss";
import { SUPPORT_EMAIL } from "../../common/constants";

export const PermissionErrorState = () => {
  return (
    <div id="permErrorState" className={styles.errorState}>
      <Message negative>
        <Message.Header>
          <FormattedMessage {...messages.permError} />
        </Message.Header>
        <p>
          <FormattedMessage {...messages.permErrorMessage} />
          {SUPPORT_EMAIL}
        </p>
      </Message>
    </div>
  );
};

export default PermissionErrorState;
